export const CHECKOUT_URL = 'https://pay.hotmart.com/A107620490Y'

export const WHATSAPP_URL =
  'https://wa.me/5491145263003?text=' +
  encodeURIComponent(
    'Hola Freddy, tengo una duda sobre el pago de Recupérate con Poder.',
  )

export type Semana = {
  numero: number
  titulo: string
  descripcion: string
}

export const semanas: Semana[] = [
  {
    numero: 1,
    titulo: 'De la Culpa al Coraje',
    descripcion:
      'Soltar el autocastigo, técnicas de PNL para dejar de rumiar el pasado.',
  },
  {
    numero: 2,
    titulo: 'De la Apatía a la Acción',
    descripcion: 'Reactivar tu energía, salir del "modo pausa".',
  },
  {
    numero: 3,
    titulo: 'De la Ira a la Libertad',
    descripcion:
      'Soltar el orgullo y el resentimiento, sin necesitar que el otro "pague".',
  },
  {
    numero: 4,
    titulo: 'Consolidar el Coraje',
    descripcion: 'Blindar el avance para no recaer en los días difíciles.',
  },
  {
    numero: 5,
    titulo: 'Amor y Blindaje',
    descripcion:
      'Prepararte para tu próxima relación desde la plenitud, no desde el miedo.',
  },
]

export type Incluido = {
  titulo: string
  detalle: string
  bono?: boolean
}

export const incluye: Incluido[] = [
  {
    titulo: '1 sesión en vivo grupal por semana (60-90 min)',
    detalle: 'Enseñanza + ejercicio práctico de PNL guiado.',
  },
  {
    titulo: 'Grupo de acompañamiento en WhatsApp',
    detalle: 'Durante las 5 semanas completas, para que nunca avances solo.',
  },
  {
    titulo: 'Meditación guiada exclusiva cada semana',
    detalle: 'Diseñada según el nivel de consciencia que se trabaja.',
  },
  {
    titulo: 'BONO: sesión de diagnóstico 1:1 de 20 minutos',
    detalle:
      'Al inicio del programa, para identificar tu punto de partida exacto.',
    bono: true,
  },
]

export const resumenEntrega: string[] = [
  '5 sesiones grupales en vivo conmigo (una por semana)',
  'Grupo de WhatsApp acompañándote los 35 días',
  '5 meditaciones guiadas, una por nivel de consciencia',
  'BONO: diagnóstico 1:1 de 20 min para arrancar',
]

export const esParaTi: string[] = [
  'Ya hiciste el test y el resultado te describió con precisión',
  'Sientes que ya pasó tiempo suficiente, pero algo sigue sin resolverse',
  'Quieres herramientas reales, con acompañamiento, no solo información suelta',
  'Estás listo/a para comprometerte con un proceso de 5 semanas',
]

export const noEsParaTi: string[] = [
  'Buscas una solución mágica de un día para el otro',
  'No puedes comprometerte con las sesiones semanales en vivo',
]

export type Testimonio = {
  quote: string
  nombre: string
  detalle: string
  destacado?: boolean
}

export const testimonios: Testimonio[] = [
  {
    quote:
      'Lo postergué dos veces pensando que el tiempo lo iba a resolver solo. Cuando finalmente entré, en la semana 2 ya había dejado de revisar su Instagram todos los días. Lo único que lamento son los seis meses que esperé.',
    nombre: 'Valentina R.',
    detalle: '34 años · Bogotá',
  },
  {
    quote:
      'Soy psicóloga y he hecho mis propios procesos terapéuticos. El mapa de niveles de consciencia trabajado con PNL me dio algo que no tenía: un orden claro para saber dónde estaba parada y qué venía después.',
    nombre: 'Marcela Ortiz',
    detalle: 'Psicóloga clínica · Buenos Aires',
  },
  {
    quote:
      'Lloré en la sesión de la semana 3. No de tristeza — de alivio. Después de un año entero, solté el rencor sin necesitar que él me pidiera perdón. Nunca creí que eso fuera posible sin que él hiciera nada.',
    nombre: 'Andrés M.',
    detalle: '41 años · Ciudad de México',
    destacado: true,
  },
]

export type Pregunta = {
  pregunta: string
  respuesta: string
}

export const faqs: Pregunta[] = [
  {
    pregunta: '¿Y si no puedo asistir a alguna sesión en vivo?',
    respuesta:
      'Todas las sesiones quedan grabadas dentro del grupo, puedes verlas después.',
  },
  {
    pregunta: '¿Esto reemplaza terapia psicológica?',
    respuesta:
      'No. Si sientes que necesitas apoyo clínico, te recomiendo complementarlo con un profesional de salud mental. Este programa se enfoca en PNL y el mapa de niveles de consciencia aplicado a rupturas.',
  },
  {
    pregunta: '¿Cuándo empiezo?',
    respuesta:
      'La fecha de inicio del próximo grupo te llega apenas confirmas tu inscripción.',
  },
  {
    pregunta: '¿Cómo es la forma de pago?',
    respuesta:
      'Pago único de $297 USD, procesado de forma segura a través de Hotmart.',
  },
]
